import { unsafeCSS } from 'lit';

import { lightTheme } from './tokens/light.js';
import { themeDeclarations } from './tokens/theme.js';

export const nsLightTheme = unsafeCSS(`:host([theme='light']) {\n${themeDeclarations(lightTheme)}\n}`);
